module.exports = __webpack_public_path__ + "img/6c9022d.jpg";